module.exports = __webpack_public_path__ + "img/opoczno_4-1.48967efe.png";